import ReportsView from "../../admin/components/reports-view"

const ClientReportsView = () => {
  return (
    <ReportsView page="client-owner" />
  )
}

export default ClientReportsView